import React from "react";
import { AgeGroup, BatchSize, CertificationBy, Duration, ProgramDelivery, Session } from "../Icons";

const FeatureBar = () => {
  const feature = [
    {
      color: "#FF663666",
      icon: <AgeGroup />,
      title: "Age group",
      subTitle: "7-17 years",
    },
    {
      color: "#923D8C36",
      icon: <ProgramDelivery />,
      title: "Program Delivery",
      subTitle: "Online",
    },
    {
      color: "#22C55E33",
      icon: <BatchSize />,
      title: "Batch size",
      subTitle: "1:1 Tutoring",
    },
    {
      color: "#089BC412",
      icon: <Session />,
      title: "Session",
      subTitle: "6 x 45-minute",
    },
    {
      color: "#923D8C36",
      icon: <Duration />,
      title: "Duration",
      subTitle: "6 days",
    },
    {
      color: "#F9881763",
      icon: <CertificationBy />,
      title: "Certification by",
      subTitle: "Steamminds.org",
    },
  ];
  return (
    <div className="-mt-[73px] ">
      <div className=" flex justify-center gap-[57px] w-full mx-auto bg-[#F5F5F5] max-w-[1728px]  h-[146px]">
        {feature.map((itm, idx) => (
            <div key={idx} className="flex pt-6 flex-col items-center max-w-[202px] w-full" style={{backgroundColor: itm.color}}>
              <div className="bg-white w-[50px] h-[50px] rounded-full flex items-center justify-center"> {itm.icon} </div>
              <h4 className="font-medium mt-[5px] text-xl tracking-[1%]">{itm.title}</h4>
              <p className="font-normal text-xl tracking-[1%]">{itm.subTitle}</p>
            </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureBar;
